export default __webpack_public_path__ + "static/1-post-49ef27df483895c2f07b620fd02de401.png";